import React from 'react'
import injectSheet from 'react-jss'
import styles from './tab-link.styles'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'

const TabLink = ({
  classes,
  children,
  theme,
  className,
  linkClassName,
  ...props
}) => (
  <NavLink
    exact={true}
    className={classNames(classes.listItem, className)}
    activeClassName={classes.active}
    {...props}>
    <span className={classNames(classes.link, linkClassName)}>{children}</span>
  </NavLink>
)

export default injectSheet(styles)(TabLink)
